import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class CommonEntityService {
    public selectPath: string;
    public selectType: string;
    public sessionId: string;
    private server_ip: string;


    private commonentity_list_url = '/api/dev/main/v1.0/commonstructure/celist';
    private commonentity_list_by_pkg_url = '/api/dev/main/v1.0/commonstructure/celistbypkg';


    constructor(private http: HttpClient, @Inject('url') private url: string) {
        this.server_ip = (url === null || url === undefined) ? 'http://10.24.19.140:5000' : url;
        this.sessionId = gsp.cache.get('sessionId');
    }

    // è·åå½åå·¥ç¨ä¸ææçceä¿¡æ¯
    getCEList(projPath: string, typeList: string): Observable<any> {
        const headers = new HttpHeaders().set('SessionId', this.sessionId);
        const url = this.server_ip + this.commonentity_list_url + '?projPath=' + projPath + '&typeList=' + typeList;
        return this.http.get(url, { headers });
    }

    // è·ååæ°æ®åä¸­æåå«çceä¿¡æ¯
    getCEListByMetadataPkg(packagePath: string, packageFullName: string): Observable<any> {
        const headers = new HttpHeaders().set('SessionId', this.sessionId);
        let realFullName = "";
        if (packagePath) {
            realFullName = packagePath.replace(/\\/g, '/') + '/' + packageFullName;
        } else {
            realFullName = packageFullName;
        }
        const encPackageFullName = encodeURIComponent(realFullName);
        const url = this.server_ip + this.commonentity_list_by_pkg_url + '?packageFullPath=' + encPackageFullName;
        return this.http.get(url, { headers });
    }

}